import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'underscore';
import { CreateMobileComponent } from './createMobileApplication';
import { SharedData } from '../shared/sharedData';
import { DeleteMobileComponent } from './deleteMobileApplication';

@Component({
    selector: 'mobile-app-management',
    templateUrl: './mobileAppManagement.html'
})
export class MobileAppManagementComponent{
    public _baseUrl: any;
    public mobileApps: any = [];
    public pageSize: any = 10;
    public page = 0;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public trackHides: any;
    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate:TranslateService,
        public _toaster: ToasterComponent,
        vcr: ViewContainerRef,
        public _location: Location,
        public modalService: NgbModal,
        public share: SharedData
        ){
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        self.getAllApps();
    }

    public getAllApps(){
        let self = this;
        let url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url,{ page: self.page, pageSize: self.pageSize }).subscribe((result) => {
            self.mobileApps = result.content;
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, (error) => {
            console.log('Error:', error);
        })
    }

    public createMobileApp(){
        let self = this;
        self.share.saveData({mobileApp:null});
        const modalRef = this.modalService.open(CreateMobileComponent)
        .result.then((result) => {
            self.getAllApps();
        }, (reason) => {});
    }

    public updateMobileApp(mobileApp) {
        let self = this;
        self.share.saveData({ mobileApp: mobileApp});
        const modalRef = this.modalService.open(CreateMobileComponent)
        .result.then((result) => {
            self.getAllApps();
        }, (reason) => {});
    }

    public deleteMobileApp(mobileApp) {
        let self = this;
        const modalRef = this.modalService.open(DeleteMobileComponent)
        .result.then((result) => {
            console.log('result::', result);
            if (result) {
                let url = self._baseUrl + 'v1/superAdmin/mobAppManagement/delete/' + mobileApp.id;
                self.http.delete(url).subscribe((result) => {
                    self.getAllApps();
                }, (error) => {
                    console.log('Error:', error);
                })
            }
        }, (reason) => {});
    }

    // pagination functions
  public onPageChange(event: number): void {
    let self = this;
    if (event === 1) {
      self.startingPage = 1;
      self.endingPage = 10;
    } else {
      self.startingPage = 1 + self.pageSize;
      if (self.collectionSize > self.endingPage) {
        self.endingPage = event + self.endingPage;
      } else {
        self.endingPage = self.collectionSize;
      }
    }
    self.page = event - 1;
    self.getAllApps();
  }
  
  public OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getAllApps();
  }
}



// WEBPACK FOOTER //
// ./src/app/superAdmin/mobileAppManagement.ts